// @flow
import { connect } from "react-redux";

import PasswordView from "./view";

import { fetchUserInfo } from "../../state/context/actions";

export default connect(
    state => ({
        userInfo: state.context.userInfo
    }),
    dispatch => ({
        onLogin: blogPassword => dispatch(fetchUserInfo(blogPassword))
    })
)(PasswordView);



// WEBPACK FOOTER //
// ./src/home-page-view/password-view/index.js